export default class VideoUtil {
  static checkBrowserSupportedVideoType() {
    const videoNode = document.createElement('video');
    const supportedMedia = {
      webm: false,
      mp4: false,
    };
    if (videoNode.canPlayType('video/webm;codecs=vp8') === 'probably') {
      supportedMedia.webm = true;
    }
    if (videoNode.canPlayType('video/mp4')) {
      supportedMedia.mp4 = true;
    }
    return supportedMedia;
  }
}
